import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hb-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent {
  @Input() public title: string;
  @Input() public icon: string;
  @Input() public iconStyles: object;
  @Input() public buttonId: string;
  @Input() public buttonType: string = 'button';
  @Input() public buttonStyles: object;
  @Input() public disabled: boolean = false;
  @Input() public marginHack: boolean = false;
  @Input() public toggledState: boolean = false;
  @Input() public routerLink: string;
  @Input() public routerLinkActive;
  @Input() public floatRight: boolean = true;
  @Input() public formId: string;
  @Input() public styleHover = true;
  @Input() public disableOutline = false;
  @Output() public clickEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}
